module.exports = __webpack_public_path__ + "media/loginBg.9c836ceb.mp4";